import Keycloak from 'keycloak-js';

const keycloakConfig = {
  url: process.env.REACT_APP_KEYCLOAK_BASE_URL!,
  realm: process.env.REACT_APP_KEYCLOAK_REALM!,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID!,
};

if (!keycloakConfig.url || !keycloakConfig.realm || !keycloakConfig.clientId) {
  throw new Error('Keycloak configuration is missing. Ensure REACT_APP_KEYCLOAK_BASE_URL, REACT_APP_KEYCLOAK_REALM, and REACT_APP_KEYCLOAK_CLIENT_ID are set in your .env file.');
}

const keycloak = new Keycloak(keycloakConfig);

export const initKeycloak = (onAppReadyCallback: () => void) => {
  keycloak
    .init({
      onLoad: 'login-required',
      pkceMethod: 'S256',
      checkLoginIframe: false,
    })
    .then(() => {
      onAppReadyCallback();
    })
    .catch((error) => {
      if (error?.error === 'interaction_required' || window.location.hash.includes('interaction_required')) {
        window.history.replaceState({}, document.title, window.location.pathname + window.location.search);
      } else {
        console.error('Failed to initialize Keycloak', error);
      }
      onAppReadyCallback();
    });
};

export default keycloak;
